// Reuse Potential Index dropdown option values.
//
// These component fields are stored in English going forward. Legacy records
// (and projects whose backend column definitions still list the original Dutch
// options) keep their Dutch values, so every consumer runs the stored value
// through `normalizeOption`: English passes through unchanged and Dutch is
// accepted as a fallback and mapped to its English equivalent.

const DUTCH_TO_ENGLISH = {
  'materialen (recyclebaar/biologisch afbreekbaar)':
    'Materials (recyclable/biodegradable)',
  'materialen (downcyclebaar)': 'Materials (downcyclable)',
  elementen: 'Elements',
  'componenten/systemen': 'Components/systems',
  basis: 'Base/load-bearing',
  intermediair: 'Intermediary',
  overig: 'Other',
  ja: 'Yes',
  nee: 'No',
};

// Canonical English values referenced by the scoring logic.
export const PRODUCT_LEVEL = {
  MATERIALS_DOWNCYCLABLE: 'Materials (downcyclable)',
  MATERIALS_RECYCLABLE: 'Materials (recyclable/biodegradable)',
  ELEMENTS: 'Elements',
  COMPONENTS_SYSTEMS: 'Components/systems',
};

export const COMPONENT_FUNCTION = {
  BASE: 'Base/load-bearing',
  INTERMEDIARY: 'Intermediary',
  OTHER: 'Other',
};

export const YES = 'Yes';
export const NO = 'No';

// Component fields whose values are option strings (English now, Dutch legacy).
export const OPTION_FIELDS = [
  'product_lvl',
  'component_function',
  'component_additional_function',
  'building_additional_function',
  'generic_component',
];

// Map any stored value (English or legacy Dutch) to its canonical English form.
export const normalizeOption = (value) => DUTCH_TO_ENGLISH[value] ?? value;
